module.exports = __webpack_public_path__ + "f3a5e34153130f3293746cc8f401b4fb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/telescope.png
// module id = 1402
// module chunks = 0